<ion-header class="ion-no-border" no-border-bottom>
  <ion-toolbar>
    <div class="title">
      @if (!isOnlyFiltersList) {
        <app-image
          class="back"
          [img]="'assets/images/icons-svg/back-button.svg'"
          (click)="backToMenu()"
        ></app-image>
      }
      <app-text
        [textSize]="TextSizes.h1Header"
        [textType]="TextType.base"
        [text]="filtersOptionsNames[activeFilterList!]"
      ></app-text>
    </div>
    <ion-buttons slot="end">
      <app-button
        (click)="clearFiltersList()"
        class="custom-btn"
        [btnType]="Buttons.small"
        [textSize]="ButtonTextSizes.btnMainSmall"
        [color]="'white'"
        [text]="'сбросить'"
        [class.disable-reset-btn]="!selectedElements.length"
        [isDisabled]="!selectedElements.length"
      ></app-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content appIonScrollBar [forceOverscroll]="false">
  @if (isNeedSearch) {
    <ion-searchbar
      placeholder="Поиск"
      [debounce]="600"
      (ionChange)="searchValueChange($event)"
    ></ion-searchbar>
  }

  <app-pagination-container
    [isLoading$]="isLoading$"
    [isAllLoaded]="isAllListDataFetched$ | async"
    [paginationData]="elements"
    [isFiltersPagination]="true"
    (emitScrolling)="getElements()"
  >
    @if (!isCheckboxType) {
      <ion-radio-group
        [value]="selectedElements.length && selectedElements[0].id"
        (ionChange)="onChange($event)"
      >
        @for (param of elements; track trackByFn($index, param)) {
          <ion-item>
            <ion-radio slot="start" [value]="param.id" mode="md" label-placement="end">
              <div class="label-flex">
                <div class="flex-column">
                  <app-text
                    [textSize]="TextSizes.mobBody"
                    [textType]="TextType.base"
                    [text]="param.name ?? (param | getFullName)"
                  ></app-text>
                </div>
              </div>
            </ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
    @if (isCheckboxType) {
      @for (param of elements; track trackByFn($index, param)) {
        <ion-item>
          <ion-checkbox
            #shopCheckbox
            slot="start"
            [value]="param.id"
            [checked]="param.id | checkIsSelected: selectedElements"
            mode="md"
            (ionChange)="onChange($event)"
            label-placement="end"
          >
            <app-text
              [textSize]="TextSizes.mobBody"
              [textType]="TextType.base"
              [text]="param.name"
            ></app-text>
          </ion-checkbox>
          @if (activeFilterList === filtersOptions.shops) {
            <div>
              <app-text
                class="text-grey"
                [textSize]="TextSizes.alert"
                [textType]="TextType.base"
                [text]="param.city.name"
                (click)="$any(shopCheckbox).el.click()"
              ></app-text>
            </div>
          }
        </ion-item>
      }
    }
  </app-pagination-container>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-buttons>
      <app-button
        class="button-footer button-list"
        [btnType]="Buttons.small"
        [textSize]="ButtonTextSizes.buttonText1"
        [text]="'готово'"
        (click)="applyFiltersList()"
      ></app-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
